import { AutogenModelRecurringCheckCall, AutogenRowRecurringCheckCall } from "./autogen/AutogenModelRecurringCheckCall";

export class ModelRecurringCheckCall extends AutogenModelRecurringCheckCall<RowRecurringCheckCall> {
	constructor() {
		super(RowRecurringCheckCall);
	}
}

export class RowRecurringCheckCall extends AutogenRowRecurringCheckCall {
}